export const pricing = {
  "breadcrumb": "Preços",
  "title": "Tarifas simples e flexíveis",
  "subtitle": "Uma comissão única de 5%, paga por quem você quiser.",
  "whoPays": {
    "title": "Quem paga as taxas?",
    "traveler": {
      "label": "Opção 1: O viajante paga (Recomendado)",
      "description": "Você recebe 100% do seu preço. O viajante adiciona 5% de taxa de serviço.",
      "badge": "Padrão"
    },
    "host": {
      "label": "Opção 2: O anfitrião paga (Pro)",
      "description": "Você paga os 5%. Preço exibido mais baixo para o viajante, ideal para empresas.",
      "badge": "Opção Pro"
    }
  },
  "guarantee": "Transparência total garantida",
  "perYear": "/ano",
  "choose": "Escolher",
  "popular": "O mais popular",
  "plans": {
    "traveler": {
      "name": "Viajante",
      "description": "Para explorar o mundo a baixo custo",
      "price": "5%",
      "period": "de comissão",
      "features": [
        "Acesso a todos os alojamentos",
        "Taxas de serviço reduzidas (5%)",
        "Seguro incluído",
        "Suporte 7/7",
        "Sem taxas ocultas"
      ]
    },
    "host": {
      "name": "Anfitrião",
      "description": "Para alugar sem taxas e trocar",
      "price": "0%",
      "period": "de comissão",
      "features": [
        "0% de comissão sobre seus rendimentos",
        "Acesso a trocas gratuitas entre anfitriões",
        "Selo \"Preço Justo\" disponível",
        "Maior visibilidade",
        "Suporte prioritário"
      ]
    }
  },
  "fairPrice": {
    "title": "Programa Preço Justo",
    "description": "Jogue o jogo, ganhe mais.",
    "benefit1": "Selo 'Preço Justo' visível",
    "benefit2": "Prioridade nos resultados",
    "benefit3": "Bônus de pontos de troca",
    "condition": "Proponha uma tarifa pelo menos 10% mais barata que em outras plataformas."
  },
  "taxAdvantage": {
    "title": "Vantagem Fiscal & Pro",
    "text": "As taxas de 5% podem ser dedutíveis se você for uma empresa. O modelo 0% simplifica a contabilidade para particulares. Consulte seu contador."
  },
  "hostExchange": {
    "title": "Sistema de Troca de Anfitrião",
    "description": "Troque suas noites ganhas por estadias gratuitas.",
    "free": "Gratuito (0€)",
    "community": "Reservado para membros verificados"
  },
  "comparison": {
    "title": "Por que é melhor?",
    "subtitle": "Compare e veja a diferença",
    "features": "Taxas",
    "airbnb": "Airbnb / Booking",
    "traveltrok": "DONKEY TRAVEL",
    "hostFees": "Taxas Anfitrião",
    "travelerFees": "Taxas Viajante",
    "exchange": "Troca Gratuita"
  },
  "testimonials": {
    "title": "O que dizem nossos membros",
    "subtitle": "Junte-se a uma comunidade que muda as regras",
    "badge": "Testemunhos",
    "exchanges": "trocas",
    "saved": "economizados",
    "verifiedMembers": "+15 000 membros",
    "completedExchanges": "+50 000 viagens",
    "totalSaved": "0% de comissão"
  },
  "faq": {
    "title": "Perguntas frequentes",
    "subtitle": "Tudo o que você precisa saber sobre nossas tarifas",
    "q1": {
      "question": "Posso mudar de plano a qualquer momento?",
      "answer": "Sim, você pode mudar para um plano superior a qualquer momento. A diferença será calculada proporcionalmente."
    },
    "q2": {
      "question": "Existem taxas adicionais?",
      "answer": "Não, nenhuma taxa oculta. O preço exibido é o preço final que você paga por ano. As trocas são então totalmente gratuitas."
    },
    "q3": {
      "question": "O que acontece se eu não estiver satisfeito?",
      "answer": "Oferecemos uma garantia de satisfação ou reembolso de 30 dias. Se não estiver satisfeito, reembolsamos integralmente."
    },
    "q4": {
      "question": "Como funciona o faturamento?",
      "answer": "Você é cobrado anualmente. Pode pagar por cartão de crédito ou transferência. O faturamento é automático e você recebe uma fatura por email."
    },
    "q5": {
      "question": "Posso cancelar minha assinatura?",
      "answer": "Sim, você pode cancelar a qualquer momento. Sua assinatura permanecerá ativa até o final do período pago."
    }
  },
  "cta": {
    "title": "Pronto para começar a aventura?",
    "subtitle": "Junte-se a milhares de proprietários que viajam gratuitamente",
    "createAccount": "Criar minha conta",
    "exploreDestinations": "Explorar destinos"
  },
  "signup": {
    "title": "Criar sua conta",
    "subtitle": "Junte-se à nossa comunidade de proprietários",
    "firstName": "Nome",
    "lastName": "Sobrenome",
    "email": "Email",
    "phone": "Telefone",
    "country": "País",
    "selectCountry": "Selecione seu país",
    "plan": "Plano",
    "selectPlan": "Selecione seu plano",
    "propertyType": "Tipo de alojamento",
    "selectPropertyType": "Selecione o tipo de alojamento",
    "terms": "Aceito os termos de uso e a política de privacidade",
    "submit": "Criar minha conta",
    "success": "Conta criada com sucesso!",
    "error": "Ocorreu um erro. Por favor, tente novamente.",
    "securityNote": "Seus dados estão seguros e nunca serão compartilhados",
    "house": "Casa",
    "apartment": "Apartamento",
    "villa": "Villa",
    "loft": "Loft",
    "other": "Outro"
  },
  "signupSection": {
    "title": "Junte-se à DONKEY TRAVEL hoje",
    "subtitle": "Crie sua conta em alguns minutos e comece a trocar sua casa com proprietários do mundo todo.",
    "verifiedMembers": "Membros verificados",
    "verifiedMembersDesc": "Todos os nossos membros são proprietários Airbnb verificados para trocas em segurança.",
    "guaranteedSavings": "Economias garantidas",
    "guaranteedSavingsDesc": "Nossos membros economizam em média 3 500€ por ano em custos de alojamento.",
    "globalNetwork": "Rede mundial",
    "globalNetworkDesc": "Aceda a mais de 15 000 alojamentos em 85 países em todo o mundo.",
    "responsiveSupport": "Suporte reativo",
    "responsiveSupportDesc": "Nossa equipe está disponível 7 dias por semana para acompanhá-lo em suas trocas."
  },
  "testimonialItems": {
    "sophie": "Graças à DONKEY TRAVEL, visitei Barcelona, Roma e Amsterdã sem pagar alojamento. A comunidade é reativa e as discussões de troca são simples.",
    "thomas": "Aderi à oferta de lançamento 2026: -50% no primeiro ano. O preço é garantido vitalício para os primeiros 1000, e troco em toda a Europa.",
    "marie": "Finalmente fiz minha primeira troca na Europa, e tudo correu bem desde a primeira mensagem até a chegada. A verificação dos perfis ajuda muito.",
    "pierre": "Para nossos alojamentos, o painel nos economiza tempo: anúncios, mensagens e disponibilidades são claros e fáceis de gerenciar."
  }
};
